import { registerBlockType } from "@wordpress/blocks";
import { Provider } from "react-redux";
import { Icon } from "@wordpress/components";
import store from "store";
import Editor from "./Edit";
import Save from "./Save";

registerBlockType("vino/register", {
	title: "Register",
	icon: {
		src: <Icon icon="admin-users" />,
	},
	category: "corksy",
	keywords: ["corksy"],
	description: "Register.",
	edit: function (props) {
		return (
			<Provider store={store}>
				<Editor {...props} />
			</Provider>
		);
	},
	save: Save,
});
